/**
 * Animator culling mode.
 */
export enum AnimatorCullingMode {
  /** Disable Culling. */
  None,
  /** Completely disabled when renderers are all culled. */
  Complete
}
